import { render, staticRenderFns } from "./addRoleModal.vue?vue&type=template&id=547e04ad&scoped=true&"
import script from "./addRoleModal.vue?vue&type=script&lang=js&"
export * from "./addRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./addRoleModal.vue?vue&type=style&index=0&id=547e04ad&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547e04ad",
  null
  
)

export default component.exports